module.exports = __webpack_public_path__ + "static/media/report_gray.0c57e528.svg";